import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const MScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 10L15.9768 3H21V20.8889H16.2907V10.6667L12.9419 16.6667H11.0581L7.7093 10.6667V21H3V3H8.02325L12 10Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'M'
);
export default MScaleMedium;
